import { injectAPISession, util } from '@monofe/apiservice';
import { IRouteTourSelectArguments, ITourSelectControllerRenderResult } from './interface';

function CanRender(route: IRouteTourSelectArguments): Promise<ITourSelectControllerRenderResult> {
    return new Promise(async function (resolve, reject) {
        try {
            const workspace = await injectAPISession().open(route.sessionName);

            await workspace.db.open();

            const language = await workspace.db.get('ILanguageDto', route.languageId ?? 0);

            const tours = await util.tours.ToursForLanguage(workspace.db, language);

            const hasMultipleTours = tours.length > 1;

            let result: ITourSelectControllerRenderResult = {
                hasEnoughDataToRender: hasMultipleTours,
            };

            if (tours.length <= 0) {
                throw Error('No tours found, unable to launch tour-select, or tour menu');
            }

            if (!result.hasEnoughDataToRender) {
                result = {
                    ...result,
                    suggestedAlternativeRoute: 'Tour',
                    additionalRouteDataNeeded: {
                        tourId: tours[0].id,
                    },
                };
            }
            resolve(result);
        } catch (error) {
            reject(error);
        }
    });
}

export default CanRender;
